import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import imageList from '../../imageList.json';


function UncontrolledExample() {
  return (
    
    <Carousel>
      {imageList.map((imagePath, index) => (
              (imagePath.indexOf('prices') !== -1) &&
        <Carousel.Item>
              <img key={index} src={`/images/${imagePath}`} alt={`Image ${index}`} class="carousel_img"/>
              <Carousel.Caption>
          </Carousel.Caption>
        </Carousel.Item>
        ))}
    </Carousel>
  );
}

export default UncontrolledExample;